export default "__VITE_ASSET__SUijx9gD__"